import { IotnetGateway } from "../../apis/stats/rest/models";
import { hasCoordinates } from "./iotnet-gateway-helpers";

/** Whether the gateway belongs to the shared, publicly accessible IoTnet tenant. */
export function isIotnetGateway(gateway: IotnetGateway): boolean {
  return gateway.tenant_name.toLowerCase() === "iotnet";
}

/**
 * Derives display tags for a gateway. Tags are deliberately untranslated
 * English, like the subscription tags elsewhere in the app.
 */
export function gatewayTags(gateway: IotnetGateway): string[] {
  const tags: string[] = [];

  tags.push(isIotnetGateway(gateway) ? "outdoor" : "indoor");

  if (!hasCoordinates(gateway)) {
    tags.push("positionless");
  }

  if (!gateway.last_seen) {
    tags.push("unseen");
  }

  return tags;
}
